import {
  SimpleGrid,
  Icon,
  Body,
  Box,
  Container,
  VStack,
  Heading,
} from '@hover/blueprint';
import React from 'react';
import { iCloudRain, iSun, iMonitor } from '@hover/icons';
import { StaticImage } from 'gatsby-plugin-image';

const CaseStudiesSlideDesktop: React.FC = () => (
  <SimpleGrid
    d={{ base: 'none', desktop: 'flex' }}
    columns={2}
    spacing={800}
    alignItems="center"
    px={200}
  >
    <VStack spacing="56px" alignItems="flex-start" alignSelf="flex-start">
      <Box flexDir="column" mb={600} maxW="560px">
        <Box flexDir="row" alignItems="center" mb={200} pb={100}>
          <Icon
            size="default"
            mr={400}
            icon={iCloudRain}
            color="brandNavy.500"
          />
          <Body size={200} isBold color="brandNavy.500">
            PROBLEM
          </Body>
        </Box>
        <Heading size={500} isDisplay marginBottom={0}>
          Rapid Roofing wanted to distinguish themselves from the high-pressure,
          murky sales approach employed by their competition.
        </Heading>
      </Box>
      <Box flexDir="column" maxW="584px">
        <Box flexDir="row" alignItems="center" mb={200} pb={100}>
          <Icon size="default" mr={400} icon={iSun} color="brandNavy.500" />
          <Body size={200} isBold color="brandNavy.500">
            SOLUTION
          </Body>
        </Box>
        <Heading size={500} isDisplay marginBottom={0}>
          Customers feel confident knowing that there’s nothing being hidden.
          After adopting HOVER, close rates on siding jobs increased from 30% to
          75%.
        </Heading>
      </Box>
      <Box flexDir="column" maxW="584px">
        <Box flexDir="row" alignItems="center" mb={200} pb={100}>
          <Icon size="default" mr={400} icon={iMonitor} color="brandNavy.500" />
          <Body size={200} isBold color="brandNavy.500">
            PRODUCT USED
          </Body>
        </Box>
        <Box flexDir="column">
          <Heading size={500} isDisplay marginBottom={100}>
            Measurements PDF
          </Heading>
          <Heading size={500} isDisplay marginBottom={0}>
            Design in 3D
          </Heading>
        </Box>
      </Box>
    </VStack>
    <Container flexDir="column" maxW="556px" px={0}>
      <StaticImage
        quality={100}
        placeholder="blurred"
        alt="real time 3d"
        src="../../../assets/images/exterior_contractor_case_study_1.png"
        height={417}
        width={556}
      />
      <Box
        p={400}
        w="100%"
        bg="brandNavy.500"
        mt={200}
        borderRadius="0 0 8px 8px"
        dropShadow="medium"
      >
        <Body size={300} color="neutral.0" isSemiBold>
          Rapid Roofing is a residential and commercial exterior contractor in
          Southeast Michigan. The company was founded by brothers Bill and Mike
          Beaty, who grew up working in the roofing industry alongside their
          father.
        </Body>
      </Box>
    </Container>
  </SimpleGrid>
);

export default CaseStudiesSlideDesktop;
